import { Transcriptions } from "../../../managers/Transcriptions.ts";
import { render } from "lit-html";
import { storage } from "../../../firebase.ts";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { HeartBank } from "../../../managers/HeartBank.ts";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebase.ts";

import { analytics, performance } from "../../../firebase.ts";
import { trace, PerformanceTrace } from "firebase/performance";
import { logEvent, setUserProperties } from "firebase/analytics";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

import template from "./sw-editor.mjs";
import Strings from "../../../models/Strings.json";
import { LANGUAGE } from "../../global.ts";
import { SwReader } from "../../sw-main/sw-reader/sw-reader.ts";

const strings: any = Strings;

export class SwEditor extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private componentTrace: PerformanceTrace;
    private transcriptions: Transcriptions = new Transcriptions(); // manager

    private transcription: string | null = null; // ID
    private language: string | null = null; // reader lang attribute; useful? deprecate?
    private text: string = "";

    private editor: HTMLElement;
    private modal: ModalInterface;

    private form: HTMLFormElement;
    private input: HTMLTextAreaElement;
    private message: HTMLParagraphElement;
    private submitBtn: HTMLButtonElement;

    private mp3Input: HTMLInputElement;
    private mp3Btn: HTMLButtonElement;
    private translateBtn: HTMLButtonElement;
    private progress: HTMLProgressElement;

    private SwReader: SwReader | null = null;
    private timer: any;

    constructor() {
        super();
        this.componentTrace = trace(performance, "component");
        this.componentTrace.putAttribute("view", "sw-editor");
        this.componentTrace.start();
        render(template(null), this);

        this.editor = this.querySelector("#sw-editor")!;
        this.form = this.querySelector("form")!;
        this.input = this.querySelector("#sw-editor-input")!;
        this.message = this.querySelector("#sw-editor-message")!;
        this.submitBtn = this.querySelector("button[type=submit]")!;

        this.mp3Input = this.querySelector("#sw-editor-mp3")!;
        this.mp3Btn = this.querySelector("#sw-editor-upload")!;
        this.translateBtn = this.querySelector("#sw-editor-translate")!;
        this.progress = this.querySelector("progress")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40", // need 40!
            closable: false,
            onHide: async () => {
                if (
                    this.input.value.trim() &&
                    this.input.value.trim() !== this.text.trim()
                ) {
                    if (navigator.onLine) {
                        const answer = confirm(strings.editor4[LANGUAGE]);
                        if (answer) this.handleSubmit();
                    } else alert(strings.offline[LANGUAGE]);
                }

                this.SwReader?.show();
                this.message.innerText = "";
                //window.location.hash = "#";
            },
            onShow: () => {
                this.editor.style.zIndex = "70";
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "sw-editor",
            override: true
        };

        this.modal = new Modal(this.editor, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.form.addEventListener("submit", this.handleSubmit.bind(this));

        //TODO: later v2 use pickFile instead
        this.mp3Btn.addEventListener("click", () => {
            this.mp3Input.click();
        });

        this.translateBtn.addEventListener(
            "click",
            this.translateToEnglish.bind(this)
        );

        this.mp3Input.addEventListener("change", this.uploadMp3.bind(this));

        this.input.addEventListener("input", async (event: Event) => {
            // save draft
            const paths = window.location.hash.split("/");
            const book = parseInt(paths[2]);
            const page = parseInt(paths[4]);

            this.transcriptions.update(
                this.transcription!,
                new Date(),
                book,
                page,
                LANGUAGE,
                LANGUAGE === "khmer" ? this.input.value.trim() : "",
                LANGUAGE === "khmer" ? "" : this.input.value.trim()
            );

            this.message.innerText = strings.editor5[LANGUAGE];
            this.message.style.color = "pink";
            clearTimeout(this.timer);
            this.timer = setTimeout(() => (this.message.innerHTML = ""), 3000);

            this.submitBtn.disabled = !(
                navigator.onLine &&
                this.input.value.trim() &&
                this.input.value.trim() !== this.text.trim()
            );
        });

        window.addEventListener(
            "offline",
            (event: Event) => (this.submitBtn.disabled = true)
        );
        window.addEventListener(
            "online",
            (event: Event) => (this.submitBtn.disabled = false)
        );

        // this.heartbank.addAuthStateListener3((hero, user) => {
        //     render(template(user), this);
        // });

        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }

    async show(
        id: string,
        language: string,
        text: string | null, // transcript can be null
        modal: SwReader
    ) {
        this.transcription = id;
        this.language = language;
        this.text = text || "";
        this.SwReader = modal;

        const label = this.querySelector("label") as HTMLLabelElement;
        label.innerHTML =
            language === "khmer"
                ? strings.khmer2[LANGUAGE]
                : strings.pali2[LANGUAGE];

        if (language === "khmer") {
            //this.input.classList.replace("moulpali", "battambang");
            this.input.classList.add("battambang");
            this.input.classList.remove("moulpali");
        } else {
            //this.input.classList.replace("battambang", "moulpali");
            this.input.classList.remove("battambang");
            this.input.classList.add("moulpali");
        }

        // get draft
        // const draft = await this.transcriptions.getByID(this.transcription);
        // this.input.value =
        //     (LANGUAGE === "khmer" ? draft?.transcript : draft?.translation) ??
        //     this.text;
        // temp for dad
        this.input.value = await navigator.clipboard.readText();

        this.submitBtn.disabled = !(
            navigator.onLine &&
            this.input.value.trim() &&
            this.input.value.trim() !== this.text.trim()
        );
        this.modal.show();
        this.input.focus();
    }

    hide() {
        this.modal.hide();
    }

    private async handleSubmit(event: Event | null = null) {
        event?.preventDefault();
        if (navigator.onLine) {
            const text = this.input.value.trim();
            const response =
                LANGUAGE === "khmer"
                    ? await this.transcriptions.updateTranscript(
                          this.transcription!,
                          this.heartbank.user!.uid,
                          text
                      )
                    : await this.transcriptions.updateTranslation(
                          this.transcription!,
                          this.heartbank.user!.uid,
                          text
                      );
            if (response === "success") {
                this.text = text;
                this.modal.hide();
                //this.form.reset();
            } else {
                this.message.innerText = `Error updating ${
                    LANGUAGE === "khmer" ? "transcript" : "translation"
                }.`;
                this.message.style.color = "red";
                if (!event) alert(this.message.innerText);
            }
        } else {
            this.message.innerText = strings.offline[LANGUAGE];
            this.message.style.color = "orange";
            if (!event) alert(this.message.innerText);
        }
    }

    private uploadMp3(event: Event) {
        if (!navigator.onLine) {
            alert(strings.offline[LANGUAGE]);
            return;
        }

        const file = this.mp3Input.files?.[0];

        if (!file) {
            this.message.innerText = strings.audio[LANGUAGE];
            this.message.style.color = "orange";
            return;
        }

        if (file.type !== "audio/mpeg") {
            this.message.innerText = strings.audio2[LANGUAGE];
            this.message.style.color = "red";
            return;
        }

        this.progress.classList.remove("hidden");
        this.progress.value = 0;
        this.mp3Btn.disabled = true;
        this.message.innerHTML = strings.audio3[LANGUAGE];
        this.message.style.color = "orange";

        try {
            // Store files under user-specific path: uid/audio/khmer/book/1/page/3
            const paths = window.location.hash.split("/");
            const book = parseInt(paths[2]);
            const page = parseInt(paths[4]);

            const fileName = file.name.replace(/\s+/g, "_"); // same filename will be replaced
            const filePath = `${
                this.heartbank.user!.uid
            }/audio/khmer/${book}/${page}`;
            const metadata = {
                customMetadata: {
                    fileName
                }
            };

            const storageRef = ref(storage, filePath);
            const uploadTask = uploadBytesResumable(storageRef, file, metadata);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    this.progress.value =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                },
                (error) => {
                    this.message.innerText = `Upload failed: ${error.message}`;
                    this.message.style.color = "red";
                    this.mp3Btn.disabled = false;
                    this.progress.classList.add("hidden");
                    this.mp3Input.value = "";
                    //this.progress.value = 0;
                    //this.mp3Input.files = null;
                },
                async () => {
                    const downloadURL = await getDownloadURL(
                        uploadTask.snapshot.ref
                    );
                    await this.transcriptions.updateAudio(
                        this.transcription!,
                        this.heartbank.user!.uid,
                        downloadURL
                    );
                    this.message.innerText = strings.audio4[LANGUAGE];
                    this.message.style.color = "green";
                    this.mp3Btn.disabled = false;
                    this.progress.classList.add("hidden");
                    this.mp3Input.value = "";
                }
            );
        } catch (error: any) {
            this.message.innerText = `Upload error: ${error.message}`;
            this.message.style.color = "red";
            this.mp3Btn.disabled = false;
            this.progress.classList.add("hidden");
            this.mp3Input.value = "";
        }
    }

    private async translateToEnglish() {
        if (!navigator.onLine) {
            alert(strings.offline[LANGUAGE]);
            return;
        }

        this.translateBtn.classList.add("cursor-progress");
        try {
            const updateTranslation = httpsCallable<{
                transcriptionId: string;
            }>(functions, "updateTranslation", {
                limitedUseAppCheckTokens: true
            });

            await updateTranslation({
                transcriptionId: this.transcription!
            });

            this.message.innerText = strings.editor6[LANGUAGE];
            this.message.style.color = "green";
        } catch (error: any) {
            this.message.innerText = `Translation error: ${error.message}`;
            this.message.style.color = "red";
        }
        this.translateBtn.classList.remove("cursor-progress");
    }
}
